import PlayerConstants from "../../../shared/constants/player";
import { setLocalStorage, getLocalStorage } from "../../../shared/utils/localStorage";
const { PLAYER_CONTROLS } = PlayerConstants;
export const shakaInitPlayerVolume = (playerMgr, volumeLevel, muteSetting, setIsMuted, setVolumeLevel) => {
  if (!playerMgr.current) {
    return;
  }
  const isPlayerMute = getLocalStorage(PLAYER_CONTROLS.MUTE) === "true";
  if (isPlayerMute) {
    playerMgr.current.setVolume(0);
    setIsMuted(true);
  } else if (volumeLevel) {
    playerMgr.current.setVolume(volumeLevel >= 100 ? 1 : volumeLevel / 100);
  } else if (muteSetting === "true") {
    playerMgr.current.setVolume(0);
  } else {
    playerMgr.current.setVolume(1);
  }

  setLocalStorage(PLAYER_CONTROLS.VOLUME, playerMgr.current.getVolume() * 100);
  setVolumeLevel(playerMgr.current.getVolume() * 100);
};

/**
 * Helper Method that sets the video players playback control state
 * @param Object Player Instance
 * @param String Playback control state
 */
export function shakaSetVideoPlayerControlState(homeVideoPlayer, controlState) {
  if (homeVideoPlayer && controlState) {
    switch (controlState.toLowerCase()) {
      case PLAYER_CONTROLS.STOP:
        if (homeVideoPlayer && homeVideoPlayer?.pause) {
          homeVideoPlayer.pause();
        }
        break;
      case PLAYER_CONTROLS.PAUSE:
        if (homeVideoPlayer && homeVideoPlayer?.pause) {
          homeVideoPlayer.pause();
        }
        break;
      case PLAYER_CONTROLS.RESUME:
        if (homeVideoPlayer && !homeVideoPlayer.destroyed && homeVideoPlayer?.isPaused()) {
          homeVideoPlayer.play();
        }
        break;
      case PLAYER_CONTROLS.CLOSE:
        if (homeVideoPlayer && !homeVideoPlayer.destroyed) {
          homeVideoPlayer.destroy();
        }
        break;
      default:
        break;
    }
  }
}

export const shakaHandlePlayPauseButton = (
  playerMgr,
  shakaSetVideoPlayerControlState,
  setPlayPauseIcon,
  signalUserActivity
) => {
  if (playerMgr.current?.isPlaying()) {
    shakaSetVideoPlayerControlState(playerMgr.current, PLAYER_CONTROLS.PAUSE);
    setPlayPauseIcon("/images/playback-play.svg");
  } else {
    shakaSetVideoPlayerControlState(playerMgr.current, PLAYER_CONTROLS.RESUME);
    setPlayPauseIcon("/images/playback-pause.svg");
  }
  signalUserActivity();
};

export const shakaSetVolume = (playerMgr, volumeLevel) => {
  playerMgr.current?.setVolume(volumeLevel / 100);
};
